import { Avatar } from "@material-ui/core";
import { memo, useContext } from "react";
import AppContext from "../../contexts/AppContext";

const CustomAvatar = memo(({ children, userId, redmineurl, ...rest }) => {
  const { state } = useContext(AppContext);
  return (
    <Avatar
      {...rest}
      src={
        state.users?.find(
          (user) => user.id === userId && user.redmineurl === redmineurl
        )?.avatar_url
      }
    >
      {children}
    </Avatar>
  );
});

export default CustomAvatar;
